import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const Trust = () => {
  const { t } = useLang();
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="scroll-mt-24 bg-[#F4F3EF] py-24 md:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.trust.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1C19] max-w-2xl">
            {t.trust.title}
          </h2>
          <p className="mt-8 text-lg md:text-xl leading-relaxed text-[#5C5C59]">
            {t.trust.body}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
